/* Copyright 2013 - 2024 Waiterio LLC */
import React from 'react'
import { Navigate } from 'react-router-dom'

export const paths = ['/']

const HomeRedirect = () => <Navigate exact to="/takeaway" />

export default HomeRedirect
